import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import StorageLocationAutocomplete from "../../../views/capture/RackLocations/StorageLocationAutocomplete/StorageLocationAutocomplete";
import SelectMobileLocationModal from "../../../views/capture/RackLocations/StorageLocationAutocomplete/SelectMobileLocationModal";

export default function SelectNewLocationWithin({ location, onClose, onSubmit }) {
  const [selectedLocation, setSelectedLocation] = useState({ warehouse: null, warehouse_locations: [] });
  const [overrideMobileLocation, setOverrideMobileLocation] = useState(false);
  const [mobileWarehouseLocation, setMobileWarehouseLocation] = useState(location);
  const warehouseMapFilters = location?.virtualPalletLocation
    ? {
        virtualPalletLocation: location.virtualPalletLocation,
        warehouse: location.warehouse,
      }
    : null;

  function handleSubmit() {
    onSubmit(
      selectedLocation.warehouse_locations || [],
      mobileWarehouseLocation,
      selectedLocation
    );
  }

  function handleChange(value) {
    setSelectedLocation(value);
  }

  function handleOverrideToggle() {
    setOverrideMobileLocation(!overrideMobileLocation);
  }

  const handleOverrideSubmit = data => {
    setMobileWarehouseLocation(data);
    handleOverrideToggle();
  };

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography fontSize={24} fontWeight={400} align="center" color="text.primary">
          Select New Location Within
        </Typography>
        <Typography fontSize={20} fontWeight={500} align="center" color="text.primary">
          {mobileWarehouseLocation.warehouse.name}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box mt={1}>
          <StorageLocationAutocomplete
            autoOpen
            value={selectedLocation}
            warehouseMapFilters={warehouseMapFilters}
            warehouseId={location?.warehouse?.id}
            onChange={handleChange}
          />
        </Box>
        {overrideMobileLocation && (
          <SelectMobileLocationModal
            warehouseId={location?.warehouse?.id}
            onClose={handleOverrideToggle}
            onOverride={handleOverrideSubmit}
            onSubmit={onSubmit}
          />
        )}
      </DialogContent>
      <DialogActions sx={{ px: 2.5, py: 2, display: "flex", justifyContent: "space-between" }}>
        <div />
        <Box display="flex" gap={1}>
          <Button onClick={onClose} variant="outlined">
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            variant="contained"
            disabled={!selectedLocation.warehouse_locations?.length}
          >
            Submit
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
